<template>
    <thead>
    <tr>
        <th class="first-column" colspan="2">{{ work.title }}</th>
        <th>
            <svg class="svg-tone-header" width="1450" height="25">
                <text class="tone-text" v-for="(t, i) in tone.list" v-bind:key="t.id"
                      v-bind:transform="toneTextTranslation(i)">{{ t.title }}
                </text>
            </svg>
        </th>
    </tr>
    </thead>
</template>
<script>
export default {
  name: 'organ-work-table-header',
  props: {
    work: {},
    tone: {}
  },
  methods: {
    toneTextTranslation (index) {
      let x = (index + 1) * 25 - 10
      return 'translate(' + x + ' 25) rotate(-90)'
    }
  }
}
</script>
<style lang="scss">
    @import "../assets/scss/variables";
    @import "~uikit/src/scss/variables-theme";

    table {
    }

    svg.svg-tone-header {
        text {
            fill: $base-body-color;
            font-family: $base-body-font-family;
            font-size: 16px;
            font-weight: 400;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/OrganWorkTableHeader.vue